// src/reducers/gallery_reducer.js
import {
  REQUEST_MEDIA,
  RECEIVE_MEDIA_SUCCESS,
  RECEIVE_MEDIA_FAILURE,
} from "../actions/gallery_actions";

const initialState = {
  items: [],
  loading: false,
  error: null,
  lastFetchedAt: null,
  key: null, // "africa/madagascar-wildlife" etc
};

export default function gallery(state = initialState, action) {
  switch (action.type) {
    case REQUEST_MEDIA:
      return {
        ...state,
        loading: true,
        error: null,
        key: action.key,
      };

    case RECEIVE_MEDIA_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        items: action.items,
        lastFetchedAt: action.receivedAt || Date.now(),
        key: action.key,
      };

    case RECEIVE_MEDIA_FAILURE:
      return {
        ...state,
        loading: false,
        items: [],
        error: action.error || "Failed to load media",
        lastFetchedAt: Date.now(),
        key: action.key,
      };

    default:
      return state;
  }
}
